import { integer, sqliteTable, text } from 'drizzle-orm/sqlite-core';

export const followers = sqliteTable('followers', {
  id: text('id').notNull().primaryKey(),
  followable_id: integer('followable_id'),
  followable_type: text('followable_type'),
  follower_id: integer('follower_id'),
  follower_type: text('follower_type'),
  created_at: text('created_at'),
  updated_at: text('updated_at'),
  deleted_at: text('deleted_at'),
  accepted: integer('accepted'),
});
